import PropTypes from 'prop-types';

export const TrendUpArrowIcon = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="3.5"
    stroke="currentColor"
    className={className}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
    />
  </svg>
);

TrendUpArrowIcon.propTypes = {
  className: PropTypes.string,
};

export const TrendDownArrowIcon = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="3.5"
    stroke="currentColor"
    className={className}
    style={{ transform: 'rotate(180deg)' }}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
    />
  </svg>
);

TrendDownArrowIcon.propTypes = {
  className: PropTypes.string,
};
